import React, { useState } from 'react';
import { Container, Row, Col, Card, Form, Button } from 'react-bootstrap';
import { AtSign, Lock, User, Mail, Key, Eye, EyeOff } from 'lucide-react';
import './Login.css';

function Login() {
  const [showPassword, setShowPassword] = useState(false);

  return (
    <Container fluid className="min-vh-100 d-flex align-items-center bg-light">
      <Container>
        <Row className="g-0 overflow-hidden rounded-4 shadow-lg">
          <Col lg={6} className="d-none d-lg-block position-relative">
            <div className="image-container position-absolute top-0 bottom-0 start-0 end-0" />
          </Col>
          <Col lg={6} className="bg-white">
            <Card className="border-0 h-100">
              <Card.Body className="d-flex flex-column justify-content-center p-5">
                <div className="text-center mb-4">
                  <h2 className="h3 mb-2 fw-bold">Connexion</h2>
                  <p className="text-muted">Connectez-vous à votre compte</p>
                </div>
                <Form>
                  <Form.Group className="mb-3">
                    <Form.Label className="mb-2">Email</Form.Label>
                    <div className="input-group">
                      <span className="input-group-text border-end-0 bg-transparent">
                        <AtSign size={20} className="text-primary" />
                      </span>
                      <Form.Control 
                        type="email" 
                        placeholder="Votre email" 
                        className="border-start-0 shadow-none" 
                      />
                    </div>
                  </Form.Group>

                  <Form.Group className="mb-3">
                    <Form.Label className="mb-2">Mot de passe</Form.Label>
                    <div className="input-group">
                      <span className="input-group-text border-end-0 bg-transparent">
                        <Lock size={20} className="text-primary" />
                      </span>
                      <Form.Control 
                        type={showPassword ? "text" : "password"} 
                        placeholder="Mot de passe" 
                        className="border-start-0 border-end-0 shadow-none" 
                      />
                      <Button 
                        variant="outline-secondary" 
                        onClick={() => setShowPassword(!showPassword)}
                        className="border-start-0"
                      >
                        {showPassword ? <EyeOff size={20} /> : <Eye size={20} />}
                      </Button>
                    </div>
                  </Form.Group>

                  <div className="d-flex justify-content-between mb-3">
                    <Form.Check type="checkbox" label="Se souvenir" />
                    <a href="#" className="text-primary small">Mot de passe oublié ?</a>
                  </div>

                  <Button variant="primary" className="w-100 py-2 mb-3">
                    Se connecter
                  </Button>

                  <div className="text-center my-3">
                    <small className="text-muted">Ou continuez avec</small>
                  </div>

                  <div className="d-flex gap-2">
                    <Button variant="outline-primary" className="w-100">
                      Google
                    </Button>
                    <Button variant="outline-dark" className="w-100">
                      Apple
                    </Button>
                  </div>

                  <div className="text-center mt-3">
                    <small>
                      Pas de compte ? <a href="/signup" className="text-primary">Inscrivez-vous</a>
                    </small>
                  </div>
                </Form>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
    </Container>
  );
}

function Signup() {
  const [showPassword, setShowPassword] = useState(false);

  return (
    <Container fluid className="min-vh-100 d-flex align-items-center bg-light">
      <Container>
        <Row className="g-0 overflow-hidden rounded-4 shadow-lg">
          <Col lg={6} className="d-none d-lg-block position-relative">
            <div className="image-container position-absolute top-0 bottom-0 start-0 end-0" />
          </Col>
          <Col lg={6} className="bg-white">
            <Card className="border-0 h-100">
              <Card.Body className="d-flex flex-column justify-content-center p-5">
                <div className="text-center mb-4">
                  <h2 className="h3 mb-2 fw-bold">Créer un compte</h2>
                  <p className="text-muted">Commencez votre aventure</p>
                </div>
                <Form>
                  <Row>
                    <Col md={6}>
                      <Form.Group className="mb-3">
                        <Form.Label className="mb-2">Prénom</Form.Label>
                        <div className="input-group">
                          <span className="input-group-text border-end-0 bg-transparent">
                            <User size={20} className="text-primary" />
                          </span>
                          <Form.Control 
                            type="text" 
                            placeholder="Prénom" 
                            className="border-start-0 shadow-none" 
                          />
                        </div>
                      </Form.Group>
                    </Col>
                    <Col md={6}>
                      <Form.Group className="mb-3">
                        <Form.Label className="mb-2">Nom</Form.Label>
                        <div className="input-group">
                          <span className="input-group-text border-end-0 bg-transparent">
                            <User size={20} className="text-primary" />
                          </span>
                          <Form.Control 
                            type="text" 
                            placeholder="Nom" 
                            className="border-start-0 shadow-none" 
                          />
                        </div>
                      </Form.Group>
                    </Col>
                  </Row>

                  <Form.Group className="mb-3">
                    <Form.Label className="mb-2">Email</Form.Label>
                    <div className="input-group">
                      <span className="input-group-text border-end-0 bg-transparent">
                        <Mail size={20} className="text-primary" />
                      </span>
                      <Form.Control 
                        type="email" 
                        placeholder="Email" 
                        className="border-start-0 shadow-none" 
                      />
                    </div>
                  </Form.Group>

                  <Form.Group className="mb-3">
                    <Form.Label className="mb-2">Mot de passe</Form.Label>
                    <div className="input-group">
                      <span className="input-group-text border-end-0 bg-transparent">
                        <Key size={20} className="text-primary" />
                      </span>
                      <Form.Control 
                        type={showPassword ? "text" : "password"} 
                        placeholder="Mot de passe" 
                        className="border-start-0 border-end-0 shadow-none" 
                      />
                      <Button 
                        variant="outline-secondary" 
                        onClick={() => setShowPassword(!showPassword)}
                        className="border-start-0"
                      >
                        {showPassword ? <EyeOff size={20} /> : <Eye size={20} />}
                      </Button>
                    </div>
                  </Form.Group>

                  <Form.Check 
                    type="checkbox" 
                    label="J'accepte les conditions d'utilisation" 
                    className="mb-3"
                  />

                  <Button variant="primary" className="w-100 py-2 mb-3">
                    S'inscrire
                  </Button>

                  <div className="text-center mt-3">
                    <small>
                      Déjà un compte ? <a href="/login" className="text-primary">Connectez-vous</a>
                    </small>
                  </div>
                </Form>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
    </Container>
  );
}

export { Login, Signup };